module.exports = __webpack_public_path__ + "static/media/whatsappIcon.51a0d52b.svg";